<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      class="form"
      :rules="rules"
    >
      <el-form-item label="客户编号" prop="companyName">
        <el-input v-model="form.uid"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="complaint">
        <el-input v-model="form.name"></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="fpCompany">
        <el-input v-model="form.pwd"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="complaint">
        <el-input v-model="form.sex"></el-input>
      </el-form-item>
      <el-form-item label="是否通过APP注册而来">
        <el-select v-model="form.fromApp">
          <el-option label="否" value="0"></el-option>
          <el-option label="是仅限商业用户" value="1"></el-option>
          <el-option label="当为民政对象" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="生日" prop="detailed">
        <el-input v-model="form.birthday"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="detailed">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="家庭电话" prop="detailed">
        <el-input v-model="form.familyPhone"></el-input>
      </el-form-item>
      <el-form-item label="社区" prop="detailed">
        <el-input v-model="form.community"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="remarks">
        <el-input t v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item label="身份证" prop="remarks">
        <el-input t v-model="form.idNumber"></el-input>
      </el-form-item>
      <el-form-item label="身份证地址" prop="remarks">
        <el-input t v-model="form.idNumberAddress"></el-input>
      </el-form-item>
      <el-form-item label="客户类型">
        <el-select v-model="form.type">
          <el-option label="普通客户" value="1"></el-option>
          <el-option label="按康宝客户" value="2"></el-option>
          <el-option label="残联" value="3"></el-option>
          <el-option label="老干部" value="4"></el-option>
          <el-option label="计生委" value="5"></el-option>
          <el-option label="援助客户" value="6"></el-option>
          <el-option label="商业客户8D类服务对象" value="7"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="照片" prop="remarks">
        <img :src="form.photo" alt="" style="width: 200px; height: 150px" />
      </el-form-item>
      <el-form-item label="二维码" prop="remarks">
        <img :src="form.photoB" alt="" style="width: 200px; height: 150px" />
      </el-form-item>

      <el-form-item label="录入时间" prop="remarks">
        <el-input t v-model="form.entrytime"></el-input>
      </el-form-item>
      <el-form-item label="录入人员" prop="remarks">
        <el-input t v-model="form.addPerson"></el-input>
      </el-form-item>
      <el-form-item label="注销时间" prop="remarks">
        <el-input t v-model="form.zhuXiaoTime"></el-input>
      </el-form-item>
      <el-form-item label="注销人员" prop="remarks">
        <el-input t v-model="form.zhuXiaoPerson"></el-input>
      </el-form-item>
      <el-form-item label="签约时间" prop="remarks">
        <el-input t v-model="form.qianYueTime"></el-input>
      </el-form-item>
      <el-form-item label="签约人员" prop="remarks">
        <el-input t v-model="form.qianYuePerson"></el-input>
      </el-form-item>
      <el-form-item label="残联证号码" prop="remarks">
        <el-input t v-model="form.canLianNumber"></el-input>
      </el-form-item>

      <el-form-item label="残疾类型">
        <el-select v-model="form.canJiType">
          <el-option label="视力残疾" value="1"></el-option>
          <el-option label="听力残疾" value="2"></el-option>
          <el-option label="语言残疾" value="3"></el-option>
          <el-option label="智力残疾" value="4"></el-option>
          <el-option label="肢体残疾" value="5"></el-option>
          <el-option label="精神残疾" value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="残疾类型">
        <el-select v-model="form.canJiIndex">
          <el-option label="特困供养人员" value="1"></el-option>
          <el-option label="低保对象" value="2"></el-option>
          <el-option label="建档立卡的贫困人口" value="3"></el-option>
          <el-option label="重点优抚对象" value="4"></el-option>
          <el-option label="计划生育特殊家庭成员" value="5"></el-option>
          <el-option label="二．三级残疾人中的老年人" value="6"></el-option>
          <el-option label="80周岁以上四级残疾老年人" value="7"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="审核拒绝原因" prop="remarks">
        <el-input t v-model="form.statesJuJue"></el-input>
      </el-form-item>
      <el-form-item label="年龄中间字段" prop="remarks">
        <el-input t v-model="form.age"></el-input>
      </el-form-item>
      <el-form-item label="身份证正面照片" prop="remarks">
        <img :src="form.picStart" alt="" style="width: 200px; height: 150px" />
      </el-form-item>
      <el-form-item label="身份证反面照片" prop="remarks">
        <img
          :src="form.idcardimgf"
          alt=""
          style="width: 200px; height: 150px"
        />
      </el-form-item>
      <el-form-item label="户口本主页照片" prop="remarks">
        <img :src="form.hkbImgZ" alt="" style="width: 200px; height: 150px" />
      </el-form-item>
      <el-form-item label="户口本本人页照片" prop="remarks">
        <img :src="form.hkbImgB" alt="" style="width: 200px; height: 150px" />
      </el-form-item>
      <el-form-item label="申请材料照片" prop="remarks">
        <img :src="form.applyImg" alt="" style="width: 200px; height: 150px" />
      </el-form-item>

      <el-form-item label="民族" prop="fpCompany">
        <el-input v-model="form.nation"></el-input>
      </el-form-item>
      <el-form-item label="经济来源" prop="fpCompany">
        <el-input v-model="form.economicSource"></el-input>
      </el-form-item>
      <el-form-item label="证号" prop="fpCompany">
        <el-input v-model="form.certificateNumber"></el-input>
      </el-form-item>
      <el-form-item label="证类型" prop="fpCompany">
        <el-input v-model="form.certificateType"></el-input>
      </el-form-item>
      <el-form-item label="其他证类型" prop="fpCompany">
        <el-input v-model="form.otherCertificateType"></el-input>
      </el-form-item>

      <el-form-item label="职务职称" prop="fpCompany">
        <el-input v-model="form.postTitle"></el-input>
      </el-form-item>
      <el-form-item label="个人爱好" prop="fpCompany">
        <el-input v-model="form.personalHobby"></el-input>
      </el-form-item>
      <el-form-item label="居住其他情况" prop="fpCompany">
        <el-input v-model="form.otherJuzhuCommunity"></el-input>
      </el-form-item>
      <el-form-item label="经济来源其他情况" prop="fpCompany">
        <el-input v-model="form.otherEconomicSource"></el-input>
      </el-form-item>
      <el-form-item label="其他爱好" prop="fpCompany">
        <el-input v-model="form.otherPersonalHobby"></el-input>
      </el-form-item>

      <el-form-item label="是否佩戴助听器" prop="fpCompany">
        <el-input v-model="form.zhuting"></el-input>
      </el-form-item>
      <el-form-item label="是否有过敏史" prop="fpCompany">
        <el-input v-model="form.allergy"></el-input>
      </el-form-item>
      <el-form-item label="血型" prop="fpCompany">
        <el-input v-model="form.bloodType"></el-input>
      </el-form-item>
      <el-form-item label="过敏类型" prop="fpCompany">
        <el-input v-model="form.allergicType"></el-input>
      </el-form-item>
      <el-form-item label="其他过敏类型" prop="fpCompany">
        <el-input v-model="form.otherAllergicType"></el-input>
      </el-form-item>

      <el-form-item label="是否佩戴助听器" prop="fpCompany">
        <el-input v-model="form.zhuting"></el-input>
      </el-form-item>
      <el-form-item label="是否有过敏史" prop="fpCompany">
        <el-input v-model="form.allergy"></el-input>
      </el-form-item>
      <el-form-item label="血型" prop="fpCompany">
        <el-input v-model="form.bloodType"></el-input>
      </el-form-item>
      <el-form-item label="过敏类型" prop="fpCompany">
        <el-input v-model="form.allergicType"></el-input>
      </el-form-item>
      <el-form-item label="其他过敏类型" prop="fpCompany">
        <el-input v-model="form.otherAllergicType"></el-input>
      </el-form-item>
      <el-form-item label="其他类型" prop="fpCompany">
        <el-input v-model="form.otherMinzhengIndex"></el-input>
      </el-form-item>

      <el-form-item label="状态改变原因" prop="fpCompany">
        <el-input v-model="form.statesChgRsn"></el-input>
      </el-form-item>
      <el-form-item label="政府免费的次数" prop="fpCompany">
        <el-input v-model="form.freeCount"></el-input>
      </el-form-item>
      <el-form-item label="实体取消时间" prop="fpCompany">
        <el-input v-model="form.isFreeDate"></el-input>
      </el-form-item>
      <el-form-item label="信息取消时间" prop="fpCompany">
        <el-input v-model="form.isDeadDate"></el-input>
      </el-form-item>
      <el-form-item label="积分" prop="fpCompany">
        <el-input v-model="form.points"></el-input>
      </el-form-item>
      <el-form-item label="兴康币" prop="fpCompany">
        <el-input v-model="form.coupon"></el-input>
      </el-form-item>

      <el-form-item label="过敏情况" prop="fpCompany">
        <el-input v-model="form.guomin"></el-input>
      </el-form-item>
      <el-form-item label="健康备注" prop="fpCompany">
        <el-input v-model="form.oldremark"></el-input>
      </el-form-item>
      <el-form-item label="现居地址" prop="fpCompany">
        <el-input v-model="form.currentAddress"></el-input>
      </el-form-item>
      <el-form-item
        label="同步码--->武汉老人卡id,8位16进制字符"
        prop="fpCompany"
      >
        <el-input v-model="form.sysEndCood"></el-input>
      </el-form-item>

      <el-form-item label="原">
        <el-select v-model="form.serviceType">
          <el-option label="维修维护服务" value="0"></el-option>
          <el-option label="保洁类服务" value="1"></el-option>
          <el-option label="生活照料类" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="家庭服务工单中服务单价" prop="detailed">
        <el-input v-model="form.unitPrice"></el-input>
      </el-form-item>

      <el-form-item label="家庭服务工单中服务面积" prop="detailed">
        <el-input v-model="form.area"></el-input>
      </el-form-item>
      <el-form-item label="家庭服务工单中服务次数" prop="detailed">
        <el-input v-model="form.num"></el-input>
      </el-form-item>
      <el-form-item label="家庭服务工单中服务优惠" prop="detailed">
        <el-input v-model="form.des"></el-input>
      </el-form-item>
      <el-form-item label="生活服务工单故障现象" prop="remarks">
        <el-input t v-model="form.failure"></el-input>
      </el-form-item>
      <el-form-item label="生活服务工单服务保障" prop="remarks">
        <el-input t v-model="form.ensure"></el-input>
      </el-form-item>
      <el-form-item label="生活服务工单修复结果" prop="remarks">
        <el-input t v-model="form.result"></el-input>
      </el-form-item>
      <el-form-item label="服务内容价格" prop="remarks">
        <el-input t v-model="form.fixPrice"></el-input>
      </el-form-item>
      <el-form-item label="上门费" prop="remarks">
        <el-input t v-model="form.serveFee"></el-input>
      </el-form-item>
      <el-form-item label="材料费" prop="remarks">
        <el-input t v-model="form.materialPrice"></el-input>
      </el-form-item>
      <el-form-item label="总计价格" prop="remarks">
        <el-input t v-model="form.totalPrice"></el-input>
      </el-form-item>
      <el-form-item label="维修服务工单中服务优惠" prop="remarks">
        <el-input t v-model="form.desServe"></el-input>
      </el-form-item>
      <el-form-item label="维修服务工单中材料优惠" prop="remarks">
        <el-input t v-model="form.desMaterial"></el-input>
      </el-form-item>
      <el-form-item label="维修服务工单中上门优惠" prop="remarks">
        <el-input t v-model="form.desFee"></el-input>
      </el-form-item>
      <el-form-item label="照料服务工单中服务优惠" prop="remarks">
        <el-input t v-model="form.desCare"></el-input>
      </el-form-item>
      <el-form-item label="服务要求" prop="remarks">
        <el-input t v-model="form.serrequire"></el-input>
      </el-form-item>
      <el-form-item label="服务时间" prop="remarks">
        <el-input t v-model="form.sertime"></el-input>
      </el-form-item>
      <el-form-item label="机构点ID  关联机构信息" prop="remarks">
        <el-input t v-model="form.serveStation"></el-input>
      </el-form-item>

      <el-form-item label="申请作废理由" prop="remarks">
        <el-input t v-model="form.closeReason"></el-input>
      </el-form-item>
      <el-form-item
        label="提交人（将申请提交给xxx用户进行调整）"
        prop="remarks"
      >
        <el-input t v-model="form.closePerson"></el-input>
      </el-form-item>

      <el-form-item label="工单状态">
        <el-select v-model="form.serviceType">
          <el-option label="待派发" value="0"></el-option>
          <el-option label="待处理" value="1"></el-option>
          <el-option label="待回访" value="2"></el-option>
          <el-option label="服务完成" value="3"></el-option>
          <el-option label="待作废" value="4"></el-option>
          <el-option label="已作废" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工单状态说明" prop="remarks">
        <el-input t v-model="form.statusDesc"></el-input>
      </el-form-item>
      <el-form-item label="客户类型说明" prop="remarks">
        <el-input t v-model="form.customerDesc"></el-input>
      </el-form-item>
      <el-form-item label="新增服务工单设置的服务次数" prop="remarks">
        <el-input t v-model="form.number"></el-input>
      </el-form-item>
      <el-form-item label="工单类型">
        <el-select v-model="form.serviceType">
          <el-option label="为民政服务工单" value="null"></el-option>
          <el-option label="为商业服务工单" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工单的APP状态">
        <el-select v-model="form.serviceType">
          <el-option label="待接单" value="1"></el-option>
          <el-option label="已接单" value="2"></el-option>
          <el-option label="执行中" value="3"></el-option>
          <el-option label="已取消" value="4"></el-option>
          <el-option label="已完成" value="5"></el-option>
          <el-option label="已评价" value="6"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="开始照片" prop="remarks">
        <img :src="form.picStart" alt="" style="width: 200px; height: 150px" />
        <!--                <el-input t v-model="form.picStart"></el-input>-->
        <!--                <el-upload-->
        <!--                        class="avatar-uploader"-->
        <!--                        :action="form.picStart"-->
        <!--                       >-->
        <!--                    <img v-if="imageUrl" :src="imageUrl" class="avatar">-->
        <!--                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
        <!--                </el-upload>-->
      </el-form-item>
      <el-form-item label="结束照片" prop="remarks">
        <!--                <el-input t v-model="form.picFinished"></el-input>-->
        <img
          :src="form.picFinished"
          alt=""
          style="width: 200px; height: 150px"
        />
      </el-form-item>
      <el-form-item label="接单时间" prop="remarks">
        <el-input t v-model="form.timeGet"></el-input>
      </el-form-item>
      <el-form-item label="开始工作时间" prop="remarks">
        <el-input t v-model="form.timeStart"></el-input>
      </el-form-item>
      <el-form-item label="结束工作时间" prop="remarks">
        <el-input t v-model="form.timeEnd"></el-input>
      </el-form-item>
      <el-form-item label="工作时长" prop="remarks">
        <el-input t v-model="form.period"></el-input>
      </el-form-item>
      <el-form-item label="用户作出的星级评价" prop="remarks">
        <el-input t v-model="form.estimateLevel"></el-input>
      </el-form-item>

      <el-form-item label="用户作出的文字评价" prop="remarks">
        <el-input t v-model="form.estimate"></el-input>
      </el-form-item>
      <el-form-item label="用户作出的语音评价" prop="remarks">
        <el-input t v-model="form.estimateRecord"></el-input>
      </el-form-item>
      <el-form-item label="订单是否通过APP发布的">
        <el-select v-model="form.serviceType">
          <el-option label="不是" value="0"></el-option>
          <el-option label="是" value="1"></el-option>
        </el-select>
      </el-form-item>

      <div class="button" v-if="buttonType == 'add'">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button type="info" @click="cancel">取消</el-button>
      </div>
      <div class="button" v-if="buttonType == 'compile'">
        <el-button type="primary" @click="save">编辑</el-button>
        <el-button type="info" @click="cancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ["buttonType", "row"],
  data() {
    return {
      form: {
        province: "",
      },
      rules: {},
    }
  },
  created() {
    this.form = this.row
    console.log("123", process.env.NODE_ENV)
  },
}
</script>

<style scoped>
.left {
  width: 45%;
  display: inline-block;
}

.right {
  width: 50%;
  display: inline-block;
  float: right;
}

.form {
  width: 90%;
}

.flex {
  display: flex;
}

.itemSelect {
  width: 30%;
}

.map {
  width: 100%;
  height: 120px;
  background-color: red;
}

.button {
  width: 400px;
  margin: 30px auto 0px;
  display: flex;
  justify-content: space-between;
}

.el-form-item {
  margin-bottom: 20px !important;
}

.el-form-item__label {
  line-height: 20px !important;
}

.el-radio {
  margin: 20px;
}
</style>
